/* Mit Motiv · “Samme motiv på mere” i kurven (18/10-2026, snippets/mm-kurv-motiv): ét tryk lægger julekortene (eller
   kruset) i kurven med vægbilledets stil og navn som linje-egenskaber, så ordreflowet bruger samme godkendte design.
   Kurv-skuffen tegnes forfra som ved rammetilbuddet (assets/mm-kurv-plus.js); på kurv-siden genindlæses siden. */
(() => {
  if (window.mmKurvMotiv) return;
  window.mmKurvMotiv = true;
  const d = document;
  const tilfoej = async (knap) => {
    const box = knap.closest('[data-mm-motiv-tilkoeb]');
    if (!box || knap.disabled) return;
    const fejl = box.querySelector('[data-mm-motiv-fejl]');
    const skuffe = box.closest('cart-drawer');
    const body = { items: [{ id: Number(box.dataset.vid), quantity: 1, properties: {
      Stil: box.dataset.stil || '', 'Samme motiv som': box.dataset.fra || '', 'Forhåndsgodkend': 'Ja' } }] };
    if (skuffe && skuffe.getSectionsToRender) { body.sections = skuffe.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
    knap.disabled = true;
    if (fejl) fejl.hidden = true;
    try {
      const url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then((r) => r.json());
      if (res.status) throw new Error(res.description || res.message || '');
      try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mm-kurv-motiv', productVariantId: Number(box.dataset.vid), cartData: res }); } catch (e) { /* ignorer */ }
      if (skuffe && res.sections && skuffe.renderContents) skuffe.renderContents(res);
      else window.location.reload();
    } catch (e) {
      knap.disabled = false;
      if (fejl) { fejl.textContent = box.dataset.fejl || ''; fejl.hidden = false; }
    }
  };
  d.addEventListener('click', (e) => {
    const knap = e.target.closest && e.target.closest('[data-mm-motiv-add]');
    if (knap) tilfoej(knap);
  });
})();
